import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms';
import { queryProcessor } from '../../model/dynamicForm/queryProcessor';
import { StandardUIService } from '../../services/standardui-service/standardui-service';

@Component({
  selector: 'app-dynamic-forms',
  templateUrl: './dynamic-forms.component.html',
  styleUrls: ['./dynamic-forms.component.scss']
})
export class DynamicFormsComponent implements OnInit {

  @Input() query: queryProcessor<any>;
  @Input() form: FormGroup;
  pickListArray = [];
  options = [];
  public settings = {};
  get isValid() { 
    return true;  
  }

  // get isValid() { 
  //   // console.log(this.form.controls);
  //   // console.log(this.query);

  //   if(this.query != undefined && this.form.controls[this.query.placeHolder]) {
  //     return this.form.controls[this.query.placeHolder].valid; 
  //   } else {
  //     // console.log('no query found');
  //   }
    
  // }
  
  constructor(public StandardUIService:StandardUIService) { 
    
  }

  ngOnInit() {
    for(let i in this.query){
      if(i == 'readonly' && this.query[i]){
        let obj:any = {};
        obj['formcontrolname'] = this.query.placeHolder;
        obj['value'] = this.query[i];
        // obj = {
        //   this.query.placeHolder:
        // }
        console.log(obj);
        this.StandardUIService.setReadOnlyInput(obj);
        this.form.controls[this.query.placeHolder].patchValue(this.query[i]);
        this.form.controls[this.query.placeHolder].disable();
      }      
    }
    this.settings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      enableSearchFilter: false,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    if(this.query && (this.query.dataType == "PickList" || this.query.dataType == "MultiSelect")) {
      //console.log(this.query);
      this.pickListArray = this.query.picklistvaluesv1;
      // console.log(this.pickListArray);
      // for(let key in this.pickListArray){
      //    this.options.push({
      //     "key" : key.split('_')[1],
      //     "value": this.pickListArray[key]
      //    });
      // }  
      // if(this.options){
      //   this.options.sort(this.SortByName);
      // }
      let selectedValArry = [];
      for(let key in this.pickListArray){
        if(this.pickListArray[key].active===true || this.pickListArray[key].active===''){
            this.options.push({
              "key" : key.split('_')[1],
              "value": this.pickListArray[key].value
            });
            for(let j in this.query){             
              if(j == 'defaultValue' && this.query[j]){   
                 //console.log(this.query[j]);
                 let ids = this.query[j].split(',');
                 //console.log(ids);
                 for(let i = 0;i < ids.length;i++){
                  if(key.split('_')[1] == ids[i]){     
                    console.log(key.split('_')[1]);                                
                    let tempVal = {
                      "key" : key.split('_')[1],
                      "value" : this.pickListArray[key].value
                    };
                    selectedValArry.push(tempVal);
                    //console.log(selectedValArry); 
                    this.StandardUIService.setDefaultFilterData(selectedValArry);                   
                    this.form.controls[this.query.placeHolder].patchValue(selectedValArry);
                  }                
                 }
                // if(key.split('_')[1] == this.query[j]){     
                //   console.log(key.split('_')[1]);            
                //   let selectedVal = [{
                //     "key" : key.split('_')[1],
                //     "value" : this.pickListArray[key].value
                //   }]
                //   console.log(selectedVal);
                //   this.form.controls[this.query.placeHolder].patchValue(selectedVal);
                // }                
              }
            }   
          }
               
      }
      if(this.options){
        this.options.sort(this.SortByName);
        const valuesToRemove = [ 'Updated', 'Open'];
        this.options = this.options.filter(option => !valuesToRemove.includes(option.value));
      }
      // console.log(this.options);
    }
  }
  SortByName(x,y) {
    return ((x.value == y.value) ? 0 : ((x.value > y.value) ? 1 : -1 ));
  } 
  onDropDownClose(e){

  }
  onItemSelect(e){

  }
  onDeSelect(e){

  }
  onSelectAll(e){

  }
  onDeSelectAll(e){

  }
}
